import {
	Dialog,
	DialogContent,
	DialogDescription,
	DialogFooter,
	DialogHeader,
	DialogTitle,
} from "@/dentlab/src/components/ui/dialog";
import { Button } from "@/dentlab/src/components/ui/button";
import { useTemplatesStore } from "@/dentlab/src/store/Templates";

interface TariffCodeChangeDialogProps {
	open: boolean;
	onOpenChange: (open: boolean) => void;
	templateIds: number[];
	oldCode: string;
	newCode: string;
	onFallbackToDefault: () => void;
	onKeepCustom: () => void;
	onCancel: () => void;
}

export const TariffCodeChangeDialog: React.FC<TariffCodeChangeDialogProps> = ({
	open,
	onOpenChange,
	templateIds,
	oldCode,
	newCode,
	onFallbackToDefault,
	onKeepCustom,
	onCancel,
}) => {
	const { templatesLookup } = useTemplatesStore((state) => ({
		templatesLookup: state.templatesLookup,
	}));

	const templateNames = templateIds
		.map((id) => templatesLookup[id]?.name || templatesLookup[id]?.code || `Template ${id}`)
		.filter(Boolean);

	return (
		<Dialog open={open} onOpenChange={onOpenChange}>
			<DialogContent>
				<DialogHeader>
					<DialogTitle>Tarifcode ändern</DialogTitle>
					<DialogDescription asChild>
						<div>
							<p className="mb-2">
								Der Tarifcode wird von "{oldCode}" zu "{newCode}" geändert.
								Dieser Tarif überschreibt einen Standardtarif und wird in folgenden Vorlagen verwendet:
							</p>
							<ul className="list-disc list-inside mb-2 max-h-40 overflow-y-auto">
								{templateNames.map((name, index) => (
									<li key={index} className="text-sm">
										{name}
									</li>
								))}
							</ul>
							<p className="text-sm text-muted-foreground">
								Möchten Sie die Vorlagen auf den Standardtarif zurücksetzen oder den geänderten Tarif behalten?
							</p>
						</div>
					</DialogDescription>
				</DialogHeader>
				<DialogFooter className="flex-col sm:flex-row gap-2">
					<Button variant="outline" onClick={onCancel}>
						Abbrechen
					</Button>
					<Button variant="outline" onClick={onFallbackToDefault}>
						Auf Standard zurücksetzen
					</Button>
					<Button variant="default" onClick={onKeepCustom}>
						Tarif behalten
					</Button>
				</DialogFooter>
			</DialogContent>
		</Dialog>
	);
};
